// test2645
(2645 && 0);
